import { render } from "./content-slider.vue?vue&type=template&id=572e742a"
import script from "./content-slider.vue?vue&type=script&lang=js"
export * from "./content-slider.vue?vue&type=script&lang=js"

import "./content-slider.vue?vue&type=style&index=0&id=572e742a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__